import { Link } from "react-router-dom";
import { categories, navLinks, siteInfo } from "@/mocks/site";

const helpful = [
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
  { label: "线索征集", to: "/contact" },
  { label: "内容原则", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-950 text-background-100">
      <div className="px-4 py-12 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                蝌
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.intro}</p>
            <p className="mt-4 text-xs text-background-400">始于 {siteInfo.since} · 关注信息本身</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">浏览栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">快捷入口</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(0, 4).map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100">关于与合作</h4>
            <ul className="mt-4 space-y-2.5">
              {helpful.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm text-background-300">
              联系邮箱：
              <a
                href={`mailto:${siteInfo.email}`}
                className="text-accent-300 transition-colors hover:text-accent-200"
              >
                {siteInfo.email}
              </a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 内容仅供参考，请以当事方与权威机构公开信息为准</p>
          <p>本站不刊登未经核实的结论，欢迎随时纠错</p>
        </div>
      </div>
    </footer>
  );
}